export const colors = [
  { borderColor: '#033047', backgroundColor: '#033047' },
  { borderColor: '#00C8E1', backgroundColor: '#00C8E1' },
  { borderColor: '#666666', backgroundColor: '#666666' },
  { borderColor: '#999999', backgroundColor: '#999999' },
  { borderColor: '#BFBFBF', backgroundColor: '#BFBFBF' },
  { borderColor: '#e9e9e9', backgroundColor: '#D9D9D9' },
  { borderColor: '#e5e5e5', backgroundColor: '#e5e5e5' },
  { borderColor: '#033047', backgroundColor: '#033047' },
  { borderColor: '#00C8E1', backgroundColor: '#00C8E1' },
  { borderColor: '#666666', backgroundColor: '#666666' },
  { borderColor: '#999999', backgroundColor: '#999999' },
  { borderColor: '#BFBFBF', backgroundColor: '#BFBFBF' },
  { borderColor: '#e9e9e9', backgroundColor: '#D9D9D9' },
  { borderColor: '#e5e5e5', backgroundColor: '#e5e5e5' },
  { borderColor: '#033047', backgroundColor: '#033047' },
  { borderColor: '#00C8E1', backgroundColor: '#00C8E1' },
  { borderColor: '#666666', backgroundColor: '#666666' },
  { borderColor: '#999999', backgroundColor: '#999999' },
  { borderColor: '#BFBFBF', backgroundColor: '#BFBFBF' },
  { borderColor: '#e9e9e9', backgroundColor: '#D9D9D9' },
  { borderColor: '#e5e5e5', backgroundColor: '#e5e5e5' },
  { borderColor: '#033047', backgroundColor: '#033047' },
  { borderColor: '#00C8E1', backgroundColor: '#00C8E1' },
  { borderColor: '#666666', backgroundColor: '#666666' },
  { borderColor: '#999999', backgroundColor: '#999999' },
  { borderColor: '#BFBFBF', backgroundColor: '#BFBFBF' },
  { borderColor: '#e9e9e9', backgroundColor: '#D9D9D9' },
  { borderColor: '#e5e5e5', backgroundColor: '#e5e5e5' },
  { borderColor: '#033047', backgroundColor: '#033047' },
  { borderColor: '#00C8E1', backgroundColor: '#00C8E1' },
  { borderColor: '#666666', backgroundColor: '#666666' },
  { borderColor: '#999999', backgroundColor: '#999999' },
  { borderColor: '#BFBFBF', backgroundColor: '#BFBFBF' },
  { borderColor: '#e9e9e9', backgroundColor: '#D9D9D9' },
  { borderColor: '#e5e5e5', backgroundColor: '#e5e5e5' },
  { borderColor: '#033047', backgroundColor: '#033047' },
  { borderColor: '#00C8E1', backgroundColor: '#00C8E1' },
  { borderColor: '#666666', backgroundColor: '#666666' },
  { borderColor: '#999999', backgroundColor: '#999999' },
  { borderColor: '#BFBFBF', backgroundColor: '#BFBFBF' },
  { borderColor: '#e9e9e9', backgroundColor: '#D9D9D9' },
  { borderColor: '#e5e5e5', backgroundColor: '#e5e5e5' },
  { borderColor: '#033047', backgroundColor: '#033047' },
  { borderColor: '#00C8E1', backgroundColor: '#00C8E1' },
  { borderColor: '#666666', backgroundColor: '#666666' },
  { borderColor: '#999999', backgroundColor: '#999999' },
  { borderColor: '#BFBFBF', backgroundColor: '#BFBFBF' },
  { borderColor: '#e9e9e9', backgroundColor: '#D9D9D9' },
  { borderColor: '#e5e5e5', backgroundColor: '#e5e5e5' },
  { borderColor: '#033047', backgroundColor: '#033047' },
  { borderColor: '#00C8E1', backgroundColor: '#00C8E1' },
  { borderColor: '#666666', backgroundColor: '#666666' },
  { borderColor: '#999999', backgroundColor: '#999999' },
  { borderColor: '#BFBFBF', backgroundColor: '#BFBFBF' },
  { borderColor: '#e9e9e9', backgroundColor: '#D9D9D9' },
  { borderColor: '#e5e5e5', backgroundColor: '#e5e5e5' },
  { borderColor: '#033047', backgroundColor: '#033047' },
  { borderColor: '#00C8E1', backgroundColor: '#00C8E1' },
  { borderColor: '#666666', backgroundColor: '#666666' },
  { borderColor: '#999999', backgroundColor: '#999999' },
  { borderColor: '#BFBFBF', backgroundColor: '#BFBFBF' },
  { borderColor: '#e9e9e9', backgroundColor: '#D9D9D9' },
  { borderColor: '#e5e5e5', backgroundColor: '#e5e5e5' },
]

export const colorsTransparent = [
  {
    borderColor: 'rgba(3, 48, 71, .5)',
    backgroundColor: 'rgba(3, 48, 71, .5)',
  },
  {
    borderColor: 'rgba(0, 200, 225, .5)',
    backgroundColor: 'rgba(0, 200, 225, .5)',
  },
  {
    borderColor: 'rgba(120, 120, 120, .5)',
    backgroundColor: 'rgba(120, 120, 120, .5)',
  },
  {
    borderColor: 'rgba(153, 153, 153, .5)',
    backgroundColor: 'rgba(153, 153, 153, .5)',
  },
  {
    borderColor: 'rgba(191, 191, 191, .5)',
    backgroundColor: 'rgba(191, 191, 191, .5)',
  },
  {
    borderColor: 'rgba(217, 217, 217, .5)',
    backgroundColor: 'rgba(217, 217, 217, .5)',
  },
  {
    borderColor: 'rgba(229, 229, 229, .5)',
    backgroundColor: 'rgba(229, 229, 229, .5)',
  },
  {
    borderColor: 'rgba(3, 48, 71, .5)',
    backgroundColor: 'rgba(3, 48, 71, .5)',
  },
  {
    borderColor: 'rgba(0, 200, 225, .5)',
    backgroundColor: 'rgba(0, 200, 225, .5)',
  },
  {
    borderColor: 'rgba(120, 120, 120, .5)',
    backgroundColor: 'rgba(120, 120, 120, .5)',
  },
  {
    borderColor: 'rgba(153, 153, 153, .5)',
    backgroundColor: 'rgba(153, 153, 153, .5)',
  },
  {
    borderColor: 'rgba(191, 191, 191, .5)',
    backgroundColor: 'rgba(191, 191, 191, .5)',
  },
  {
    borderColor: 'rgba(217, 217, 217, .5)',
    backgroundColor: 'rgba(217, 217, 217, .5)',
  },
  {
    borderColor: 'rgba(229, 229, 229, .5)',
    backgroundColor: 'rgba(229, 229, 229, .5)',
  },
  {
    borderColor: 'rgba(3, 48, 71, .5)',
    backgroundColor: 'rgba(3, 48, 71, .5)',
  },
  {
    borderColor: 'rgba(0, 200, 225, .5)',
    backgroundColor: 'rgba(0, 200, 225, .5)',
  },
  {
    borderColor: 'rgba(120, 120, 120, .5)',
    backgroundColor: 'rgba(120, 120, 120, .5)',
  },
  {
    borderColor: 'rgba(153, 153, 153, .5)',
    backgroundColor: 'rgba(153, 153, 153, .5)',
  },
  {
    borderColor: 'rgba(191, 191, 191, .5)',
    backgroundColor: 'rgba(191, 191, 191, .5)',
  },
  {
    borderColor: 'rgba(217, 217, 217, .5)',
    backgroundColor: 'rgba(217, 217, 217, .5)',
  },
  {
    borderColor: 'rgba(229, 229, 229, .5)',
    backgroundColor: 'rgba(229, 229, 229, .5)',
  },
  {
    borderColor: 'rgba(3, 48, 71, .5)',
    backgroundColor: 'rgba(3, 48, 71, .5)',
  },
  {
    borderColor: 'rgba(0, 200, 225, .5)',
    backgroundColor: 'rgba(0, 200, 225, .5)',
  },
  {
    borderColor: 'rgba(120, 120, 120, .5)',
    backgroundColor: 'rgba(120, 120, 120, .5)',
  },
  {
    borderColor: 'rgba(153, 153, 153, .5)',
    backgroundColor: 'rgba(153, 153, 153, .5)',
  },
  {
    borderColor: 'rgba(191, 191, 191, .5)',
    backgroundColor: 'rgba(191, 191, 191, .5)',
  },
  {
    borderColor: 'rgba(217, 217, 217, .5)',
    backgroundColor: 'rgba(217, 217, 217, .5)',
  },
  {
    borderColor: 'rgba(229, 229, 229, .5)',
    backgroundColor: 'rgba(229, 229, 229, .5)',
  },
  {
    borderColor: 'rgba(3, 48, 71, .5)',
    backgroundColor: 'rgba(3, 48, 71, .5)',
  },
  {
    borderColor: 'rgba(0, 200, 225, .5)',
    backgroundColor: 'rgba(0, 200, 225, .5)',
  },
  {
    borderColor: 'rgba(120, 120, 120, .5)',
    backgroundColor: 'rgba(120, 120, 120, .5)',
  },
  {
    borderColor: 'rgba(153, 153, 153, .5)',
    backgroundColor: 'rgba(153, 153, 153, .5)',
  },
  {
    borderColor: 'rgba(191, 191, 191, .5)',
    backgroundColor: 'rgba(191, 191, 191, .5)',
  },
  {
    borderColor: 'rgba(217, 217, 217, .5)',
    backgroundColor: 'rgba(217, 217, 217, .5)',
  },
  {
    borderColor: 'rgba(229, 229, 229, .5)',
    backgroundColor: 'rgba(229, 229, 229, .5)',
  },
  {
    borderColor: 'rgba(3, 48, 71, .5)',
    backgroundColor: 'rgba(3, 48, 71, .5)',
  },
  {
    borderColor: 'rgba(0, 200, 225, .5)',
    backgroundColor: 'rgba(0, 200, 225, .5)',
  },
  {
    borderColor: 'rgba(120, 120, 120, .5)',
    backgroundColor: 'rgba(120, 120, 120, .5)',
  },
  {
    borderColor: 'rgba(153, 153, 153, .5)',
    backgroundColor: 'rgba(153, 153, 153, .5)',
  },
  {
    borderColor: 'rgba(191, 191, 191, .5)',
    backgroundColor: 'rgba(191, 191, 191, .5)',
  },
  {
    borderColor: 'rgba(217, 217, 217, .5)',
    backgroundColor: 'rgba(217, 217, 217, .5)',
  },
  {
    borderColor: 'rgba(229, 229, 229, .5)',
    backgroundColor: 'rgba(229, 229, 229, .5)',
  },
  {
    borderColor: 'rgba(3, 48, 71, .5)',
    backgroundColor: 'rgba(3, 48, 71, .5)',
  },
  {
    borderColor: 'rgba(0, 200, 225, .5)',
    backgroundColor: 'rgba(0, 200, 225, .5)',
  },
  {
    borderColor: 'rgba(120, 120, 120, .5)',
    backgroundColor: 'rgba(120, 120, 120, .5)',
  },
  {
    borderColor: 'rgba(153, 153, 153, .5)',
    backgroundColor: 'rgba(153, 153, 153, .5)',
  },
  {
    borderColor: 'rgba(191, 191, 191, .5)',
    backgroundColor: 'rgba(191, 191, 191, .5)',
  },
  {
    borderColor: 'rgba(217, 217, 217, .5)',
    backgroundColor: 'rgba(217, 217, 217, .5)',
  },
  {
    borderColor: 'rgba(229, 229, 229, .5)',
    backgroundColor: 'rgba(229, 229, 229, .5)',
  },
  {
    borderColor: 'rgba(3, 48, 71, .5)',
    backgroundColor: 'rgba(3, 48, 71, .5)',
  },
  {
    borderColor: 'rgba(0, 200, 225, .5)',
    backgroundColor: 'rgba(0, 200, 225, .5)',
  },
  {
    borderColor: 'rgba(120, 120, 120, .5)',
    backgroundColor: 'rgba(120, 120, 120, .5)',
  },
  {
    borderColor: 'rgba(153, 153, 153, .5)',
    backgroundColor: 'rgba(153, 153, 153, .5)',
  },
  {
    borderColor: 'rgba(191, 191, 191, .5)',
    backgroundColor: 'rgba(191, 191, 191, .5)',
  },
  {
    borderColor: 'rgba(217, 217, 217, .5)',
    backgroundColor: 'rgba(217, 217, 217, .5)',
  },
  {
    borderColor: 'rgba(229, 229, 229, .5)',
    backgroundColor: 'rgba(229, 229, 229, .5)',
  },
  {
    borderColor: 'rgba(3, 48, 71, .5)',
    backgroundColor: 'rgba(3, 48, 71, .5)',
  },
  {
    borderColor: 'rgba(0, 200, 225, .5)',
    backgroundColor: 'rgba(0, 200, 225, .5)',
  },
  {
    borderColor: 'rgba(120, 120, 120, .5)',
    backgroundColor: 'rgba(120, 120, 120, .5)',
  },
  {
    borderColor: 'rgba(153, 153, 153, .5)',
    backgroundColor: 'rgba(153, 153, 153, .5)',
  },
  {
    borderColor: 'rgba(191, 191, 191, .5)',
    backgroundColor: 'rgba(191, 191, 191, .5)',
  },
  {
    borderColor: 'rgba(217, 217, 217, .5)',
    backgroundColor: 'rgba(217, 217, 217, .5)',
  },
  {
    borderColor: 'rgba(229, 229, 229, .5)',
    backgroundColor: 'rgba(229, 229, 229, .5)',
  },
]
